import * as React from "react";
import { Polyline } from "icons";

function PolylineWr(props) {
  return <Polyline width={25} height={25} {...props} />;
}

export default PolylineWr;
